import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DriversService {
  constructor(private http:HttpClient) { }


  getDrivers(data:any){
    return this.http.post(environment.apiUrl+"drivers/get/pagination" , data);
  }

  getDeletedDrivers(data:any){
    return this.http.post(environment.apiUrl+"drivers/getByDelete/pagination" , data);
  }

  updateDriver(data:any){
    return this.http.post(environment.apiUrl+"driver/userInformation/update" , data   );
  }

  searchDrivers(data:any){
    return this.http.post(environment.apiUrl+"driver/search" , data);
  }

  getDriverUploadedDocuments(data:any){
    return this.http.post(environment.apiUrl + "driver/documents/get/all" , data)
  }
  getAllvehicles(data:any){
    return this.http.post(environment.apiUrl+"vehicles/get/all" , data);
  }

   getDriverByID(data:any){
    return this.http.post(environment.apiUrl+"driver/get/byId" , data);
  }




}
